import "./ConventionTotalHours.scss";

export default {
  root: "im-convention-total-hours",
  illustrationWrapper: "im-convention-total-hours__illustration-wrapper",
};
